import React, { FC, useEffect, useState } from 'react'
import { DialogProps, Grid, Radio, Typography } from '@mui/material'
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded'
import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import Button from '@mui/material/Button'
import { GridColDef } from '@mui/x-data-grid'
import { DataGridCustom } from 'pages/CreateHearing/components/StepIdentification/components/ModalSearchTeenager/styles'
import { PromotoriaType } from 'hooks/promotoria.hook'

type ModalPromotoriaProps = {
  open: boolean
  promotorias?: PromotoriaType[]
  onClose: (value?: PromotoriaType) => void
}

export const ModalPromotoria: FC<ModalPromotoriaProps> = ({ onClose, open, promotorias }) => {
  const [fullWidth] = useState(true)
  const [maxWidth] = useState<DialogProps['maxWidth']>('lg')

  const [data, setData] = useState<PromotoriaType[]>([])
  const [selectionModel, setSelectionModel] = useState<number[]>([])

  useEffect(() => {
    if (promotorias) {
      setData(promotorias)
    }
  }, [promotorias])

  const columns: GridColDef<any, any, any>[] = [
    {
      field: 'radiobutton',
      headerName: '',
      width: 70,
      sortable: false,
      disableReorder: true,
      disableExport: true,
      disableColumnMenu: true,
      renderCell: (params) => <Radio checked={selectionModel[0] === params.id} value={params.id} />,
    },
    {
      field: 'temNotificacao',
      headerName: 'Dot',
      width: 20,
      sortable: false,
      disableReorder: true,
      disableExport: true,
      disableColumnMenu: true,
      renderCell: (params) =>
        params.value === true ? (
          <NotificationsRoundedIcon fontSize='small' sx={{ color: '#b5aeae' }} />
        ) : null,
    },
    {
      field: 'descricao',
      headerName: 'Descrição',
      flex: 1,
      minWidth: 800,
      sortable: false,
      disableReorder: true,
      disableExport: true,
      disableColumnMenu: true,
    },
  ]

  const handleClose = () => {
    if (promotorias) {
      const result = promotorias.find((item) => String(item.id) == String(selectionModel[0]))
      onClose(result)
    }
  }

  return (
    <Dialog onClose={handleClose} open={open} fullWidth={fullWidth} maxWidth={maxWidth}>
      <DialogTitle>
        <Typography variant={'h6'} color={'primary.main'}>
          Selecione o órgão...
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Grid container direction='column' spacing={4}>
          <Grid item xs={12}>
            <DataGridCustom
              rows={data}
              columns={columns}
              autoHeight
              rowSelectionModel={selectionModel}
              onRowSelectionModelChange={(newSelectionModel: any) => {
                setSelectionModel(newSelectionModel)
              }}
              localeText={{
                footerRowSelected: (numero) =>
                  numero > 1 ? `${numero} selecionados` : `${numero} selecionado.`,
              }}
              paginationMode='server'
              hideFooterPagination
              slots={{
                columnHeaders: () => null,
              }}
            />
          </Grid>
          <Grid item xs={12} display={'flex'} justifyContent={'center'}>
            <Button
              variant='outlined'
              onClick={async () => {
                onClose()
              }}
            >
              Voltar
            </Button>
            <Button
              variant='contained'
              color='secondary'
              onClick={() => {
                handleClose()
              }}
              sx={{
                marginLeft: '0.5rem',
              }}
            >
              Selecionar
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}
